<!--
  name : 김혜진
  desc : 대시보드
  date : 2020-10-20
-->
<template>
  <v-container id="dashB" class="con_mpw">
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="5" lg="3">
        <v-row no-gutters class="mb-6">
          <div class="dashB_pic_cov">
            <div class="dashB_pic_cov" v-if="getOrgname()">
              <div class="dashB_pic cpn">
                <v-img :src="UserImgUrl" style="height: 100%"></v-img>
              </div>
              <v-chip class="pic_userChip st02">기업</v-chip>
            </div>
            <div class="dashB_pic_cov" v-else>
              <div class="dashB_pic">
                <v-img
                  :src="this.$store.state.user.userImg"
                  style="height: 100%"
                ></v-img>
              </div>
              <v-chip class="pic_userChip">개인</v-chip>
            </div>
          </div>
          <div class="dashB_info_cov">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title v-if="getOrgname()">{{
                  getOrgname()
                }}</v-list-item-title>
                <v-list-item-subtitle>{{ getName() }} 님</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
        </v-row>

        <!--요금정보-->
        <v-row no-gutters bottom v-if="getOrgname()">
          <div class="dashB_cash" @click="goFeepay">
            <span class="icon01"></span>
            <span class="txt01">요금정보</span>
            <span class="txt02">{{ availableNumber | WithComma }}건</span>
            <span class="icon02"></span>
          </div>
        </v-row>
      </v-col>

      <!--전체문서-->
      <v-col cols="12" sm="12" md="7" lg="9">
        <div class="dashB_doc_title">
          <span class="mr-5">최근문서</span>
          <span class="mr-2">{{ statCount.totalCnt }}</span
          ><span>건</span>
        </div>
        <v-row no-gutters class="dashB_docCon">
          <ul>
            <li>
              <div class="dashB_docBox st01" @click="storage('PR')">
                <v-chip>검토요청</v-chip>
                <span class="arr_i"></span>
                <span class="icon"></span>
                <div class="dashB_doc_num">
                  <span class="txt_num">{{ statCount.prCnt }}</span>
                  <span>건</span>
                </div>
              </div>
            </li>
            <li>
              <div class="dashB_docBox st02" @click="storage('CRR')">
                <v-chip>내 서명대기</v-chip>
                <span class="arr_i"></span>
                <span class="icon"></span>
                <div class="dashB_doc_num">
                  <span class="txt_num">{{ statCount.crrCnt }}</span>
                  <span>건</span>
                </div>
              </div>
            </li>
            <li>
              <div class="dashB_docBox st03" @click="storage('CRS')">
                <v-chip>서명대기</v-chip>
                <span class="arr_i"></span>
                <span class="icon"></span>
                <div class="dashB_doc_num">
                  <span class="txt_num">{{ statCount.crsCnt }}</span>
                  <span>건</span>
                </div>
              </div>
            </li>
            <li>
              <div class="dashB_docBox st04" @click="storage('CN')">
                <v-chip>거부</v-chip>
                <span class="arr_i"></span>
                <span class="icon"></span>
                <div class="dashB_doc_num">
                  <span class="txt_num">{{ statCount.cnCnt }}</span>
                  <span>건</span>
                </div>
              </div>
            </li>
          </ul>
        </v-row>
      </v-col>

      <!-- 전자 계약 시작하기 -->
      <v-col cols="12">
        <div class="btn_go_write">
          <div class="btn_icon_bg" @click="goWrite">
            <v-img
              class="img01"
              src="@/assets/img/btn_go_write_txt01.png"
              art=" 아이콘"
            ></v-img>
            <div class="btn_icon_txt">전자 계약을 시작합니다</div>
            <v-img
              class="img02"
              src="@/assets/img/btn_go_write_txt02.png"
              art="전자계약시작하기"
            ></v-img>
          </div>
        </div>
      </v-col>

      <!-- Event -->
      <v-col cols="auto" class="WdashB_event">
        <h1 class="dashB_h1">이벤트</h1>
        <div class="dashB_event">
          <v-carousel
            :continuous="false"
            :cycle="cycle"
            :show-arrows="false"
            hide-delimiter-background
            delimiter-icon="mdi-minus"
            height="auto"
          >
            <!--배너 반복부분: v-carousel-item -->
            <v-carousel-item>
              <v-sheet height="100%" tile>
                <v-row
                  no-gutters
                  class="fill-height"
                  align="center"
                  justify="center"
                >
                  <div class="bannerIcon">
                    <v-img src="@/assets/img/banner/Ebanner00.jpg"></v-img>
                  </div>
                </v-row>
              </v-sheet>
            </v-carousel-item>
          </v-carousel>
        </div>
      </v-col>

      <!-- 공지사항 -->
      <v-col cols="auto" class="WdashB_noti">
        <h1 class="dashB_h1">공지사항</h1>
        <div class="dashB_notice">
          <v-slide-group show-arrows>
            <v-slide-item>
              <v-card class="dashB_n_list" @click="popNoti_250123 = true">
                <span class="noti_chip st01">공지</span>
                <v-list-item class="title">
                  <v-list-item-content>
                    <v-list-item-title
                      >데이터베이스 저장소 확장에 따른 서버 작업 안내</v-list-item-title
                    >
                    <v-list-item-subtitle>2025-05-16</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <div class="txt">
                  안녕하세요? 비즈니스온커뮤니케이션 입니다.<br />
                </div>
              </v-card>
            </v-slide-item>
            <!-- <v-slide-item>
              <v-card class="dashB_n_list" @click="popNoti_241118 = true">
                <span class="noti_chip st01">공지</span>
                <v-list-item class="title">
                  <v-list-item-content>
                    <v-list-item-title
                      >한국정보인증 네트워크 작업에 따른 안내</v-list-item-title
                    >
                    <v-list-item-subtitle>2024-11-18</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <div class="txt">
                  안녕하세요? 비즈니스온커뮤니케이션 입니다.<br />
                </div>
              </v-card>
            </v-slide-item> -->
            <v-slide-item>
              <v-card class="dashB_n_list" @click="popNoti_240719 = true">
                <span class="noti_chip st01">공지</span>
                <v-list-item class="title">
                  <v-list-item-content>
                    <v-list-item-title
                      >글로싸인엔터프라이즈 파일서버 교체 작업에 따른 안내</v-list-item-title
                    >
                    <v-list-item-subtitle>2024-07-16</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <div class="txt">
                  안녕하세요? 비즈니스온커뮤니케이션 입니다.<br />
                </div>
              </v-card>
            </v-slide-item>
            <v-slide-item>
              <v-card class="dashB_n_list" @click="popNoti_240415 = true">
                <span class="noti_chip st01">공지</span>
                <v-list-item class="title">
                  <v-list-item-content>
                    <v-list-item-title
                      >개인정보처리방침 변경 공지</v-list-item-title
                    >
                    <v-list-item-subtitle>2024-04-15</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <div class="txt">
                  안녕하세요? 비즈니스온커뮤니케이션 입니다.<br />
                </div>
              </v-card>
            </v-slide-item>
            <v-slide-item>
              <v-card class="dashB_n_list" @click="popNoti_221005 = true">
                <span class="noti_chip st01">공지</span>
                <v-list-item class="title">
                  <v-list-item-content>
                    <v-list-item-title
                      >이용약관/개인정보취급방침 변경 공지</v-list-item-title
                    >
                    <v-list-item-subtitle>2022-10-05</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <div class="txt">
                  10월 12일부터 변경된 서비스 약관 및 개인정보취급방침으로
                  효력이 발생합니다.
                </div>
              </v-card>
            </v-slide-item>
            <v-slide-item>
              <v-card class="dashB_n_list" @click="popNoti_220923 = true">
                <span class="noti_chip st01">공지</span>
                <v-list-item class="title">
                  <v-list-item-content>
                    <v-list-item-title
                      >스마트빌싸인 서비스명 변경 안내</v-list-item-title
                    >
                    <v-list-item-subtitle>2022-09-23</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <div class="txt">
                  안녕하세요? 비즈니스온커뮤니케이션 입니다.<br /><br />보다
                  나은 서비스 제공을 위해 <br />
                </div>
              </v-card>
            </v-slide-item>
            <v-slide-item>
              <v-card class="dashB_n_list" @click="popNoti01 = true">
                <span class="noti_chip st01">공지</span>
                <v-list-item class="title">
                  <v-list-item-content>
                    <v-list-item-title
                      >이용약관/개인정보취급방침 변경 공지</v-list-item-title
                    >
                    <v-list-item-subtitle>2020-12-07</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <div class="txt">
                  12월 14일부터 변경된 서비스 약관 및 개인정보취급방침으로
                  효력이 발생합니다.
                </div>
              </v-card>
            </v-slide-item>
            <v-slide-item>
              <v-card class="dashB_n_list" @click="popNoti02 = true">
                <span class="noti_chip">일반</span>
                <v-list-item class="title">
                  <v-list-item-content>
                    <v-list-item-title
                      >스마트빌싸인 리뉴얼 오픈 안내</v-list-item-title
                    >
                    <v-list-item-subtitle>2020-12-07</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <div class="txt">
                  스마트빌 전자계약이 스마트빌싸인으로 새로워졌습니다.<br />더
                  편리하고 안전한 전자계약을 경험해보세요!
                </div>
              </v-card>
            </v-slide-item>
          </v-slide-group>
        </div>
      </v-col>
    </v-row>
    <!-- /공지사항 -->

    <!--팝업-->

    <!--한국정보인증 네트워크 작업에 따른 안내-->
    <v-dialog id="mw1264_fix100" v-model="popNoti_241118" max-width="1100">
      <v-card id="popupBox" class="popW1340VH100 popDocuD_pd_bt">
        <v-card-title class="noti_pop_title align-start">
          <v-btn
            fab
            class="popBtnClose"
            @click="popNoti_241118 = false"
          ></v-btn>
          <v-list-item class="noti_carD forPop">
            <div class="carD_01">
              <div class="carD_01_txt">
                <span class="noti_chip st01">공지</span
                ><!--상태
                ***상태별 텍스트 변경***  /*일반 / st01:공지 **/-->
                <!--공지 제목--><span class="st_tt_01"
                  >한국정보인증 네트워크 작업에 따른 안내</span
                >
              </div>
              <div class="dateBox">
                <span class="st_txt mr-5">2024-11-18</span>
              </div>
            </div>
          </v-list-item>
        </v-card-title>
        <!-- /상세 상단 -->
        <!-- 내용 -->
        <v-card-text class="noti_pop_con for_dashB"
          ><br />
          안녕하세요? 비즈니스온커뮤니케이션 입니다.<br /><br />
          전자계약 내 공동인증서 툴킷인 한국정보인증의 시스템 작업을 안내드립니다.<br /><br />
          한국정보인증(주) 네트워크 교체 작업을 아래와 같이 실시할 예정입니다. <br /><br />
          - 작업 일시 : 2024년 11월 24일(일) 00:00 ~ 11월 24일(일) 04:00 (약 4시간)<br /><br />
          ※ 해당 작업 중에는 전자계약 서비스내의 공동인증 서비스의 사용이 원활하지 않습니다.<br />
          작업 일시를 확인하셔서 서비스 이용에 참고하시기 바랍니다.<br /><br />
          감사합니다.
        </v-card-text>
        <!-- /내용 -->
        <!--버튼-->
        <v-card-actions class="justify-center btnPopcon">
          <v-btn text @click="popNoti_241118 = false">닫기</v-btn>
        </v-card-actions>
        <!--/버튼-->
      </v-card>
    </v-dialog>
    <!--한국정보인증 네트워크 작업에 따른 안내-->

    <!--설날 연휴에 따른 휴무 공지-->
    <v-dialog id="mw1264_fix100" v-model="popNoti_250123" max-width="1100">
      <v-card id="popupBox" class="popW1340VH100 popDocuD_pd_bt">
        <v-card-title class="noti_pop_title align-start">
          <v-btn
            fab
            class="popBtnClose"
            @click="popNoti_250123 = false"
          ></v-btn>
          <v-list-item class="noti_carD forPop">
            <div class="carD_01">
              <div class="carD_01_txt">
                <span class="noti_chip st01">공지</span
                ><span class="st_tt_01"
                  >데이터베이스 저장소 확장에 따른 서버 작업 안내</span
                >
              </div>
              <div class="dateBox">
                <span class="st_txt mr-5">2025-05-16</span>
              </div>
            </div>
          </v-list-item>
        </v-card-title>
        <!-- /상세 상단 -->
        <!-- 내용 -->
        <v-card-text class="noti_pop_con for_dashB">
          <br />
          안녕하세요, 비즈니스온커뮤니케이션입니다.<br />
          데이터베이스 저장소 확장 작업의 일환으로 전체 데이터 이관이 예정되어 있습니다.<br /><br />
          데이터 작업 및 점검이 이루어지는 동안 서비스 이용이 불가피하게 중단됨을 안내 드립니다.<br /><br />
          - 작업 일시 : 2025년 5월 23일 22:00 ~ 2025년 5월 24일 12:00<br />
          - 정상화 일시 : 5월24일 12:00 ~<br /><br />
          안정적인 서비스를 제공할 수 있도록 양해 부탁드립니다.<br /><br />
          감사합니다.<br />
        </v-card-text>
        <!-- /내용 -->
        <!--버튼-->
        <v-card-actions class="justify-center btnPopcon">
          <v-btn text @click="popNoti_250123 = false">닫기</v-btn>
        </v-card-actions>
        <!--/버튼-->
      </v-card>
    </v-dialog>
    <!--설날 연휴에 따른 휴무 공지-->

    <!--파일서버 이관 작업 공지-->
    <v-dialog id="mw1264_fix100" v-model="popNoti_240719" max-width="1100">
      <v-card id="popupBox" class="popW1340VH100 popDocuD_pd_bt">
        <v-card-title class="noti_pop_title align-start">
          <v-btn
            fab
            class="popBtnClose"
            @click="popNoti_240719 = false"
          ></v-btn>
          <v-list-item class="noti_carD forPop">
            <div class="carD_01">
              <div class="carD_01_txt">
                <span class="noti_chip st01">공지</span
                ><!--상태
                ***상태별 텍스트 변경***  /*일반 / st01:공지 **/-->
                <!--공지 제목--><span class="st_tt_01"
                  >글로싸인엔터프라이즈 파일서버 교체 작업에 따른 안내</span
                >
              </div>
              <div class="dateBox">
                <span class="st_txt mr-5">2024-07-16</span>
              </div>
            </div>
          </v-list-item>
        </v-card-title>
        <!-- /상세 상단 -->
        <!-- 내용 -->
        <v-card-text class="noti_pop_con for_dashB"
          ><br />
          안녕하세요? 비즈니스온커뮤니케이션 입니다.<br /><br />
          보다 원활한 전자계약 서비스 제공을 위한 <br />
          글로싸인엔터프라이즈 파일서버 교체 작업이 아래와 같이 예정되어있습니다. <br /><br />
          - 작업 일시 : 2024년 07월 19일 20:00 ~ 07월 20일 12:00 (총 16시간)<br /><br />
          ※ 해당 작업 중에는 전자계약 서비스가 제공되지 않으니,<br />
          작업 일시를 확인하셔서 서비스 이용에 참고하시기 바랍니다.<br /><br />
          ※ 작업 일정은 당일 사정에 의해 다소 변동이 생길 수 있으며,<br />
          변동 시 웹사이트를 통해 재공지 드리겠습니다.<br /><br />
          감사합니다.
        </v-card-text>
        <!-- /내용 -->
        <!--버튼-->
        <v-card-actions class="justify-center btnPopcon">
          <v-btn text @click="popNoti_240719 = false">닫기</v-btn>
        </v-card-actions>
        <!--/버튼-->
      </v-card>
    </v-dialog>
    <!--파일서버 이관 작업 공지-->

    <!--스마트빌싸인 서비스명 변경:개인정보처리방침 변경 공지 변경 공지-->
    <v-dialog id="mw1264_fix100" v-model="popNoti_240415" max-width="1100">
      <v-card id="popupBox" class="popW1340VH100 popDocuD_pd_bt">
        <v-card-title class="noti_pop_title align-start">
          <v-btn
            fab
            class="popBtnClose"
            @click="popNoti_240415 = false"
          ></v-btn>
          <v-list-item class="noti_carD forPop">
            <div class="carD_01">
              <div class="carD_01_txt">
                <span class="noti_chip st01">공지</span
                ><!--상태
                ***상태별 텍스트 변경***  /*일반 / st01:공지 **/-->
                <!--공지 제목--><span class="st_tt_01"
                  >개인정보처리방침 변경 공지</span
                >
              </div>
              <div class="dateBox">
                <span class="st_txt mr-5">2024-04-15</span>
              </div>
            </div>
          </v-list-item>
        </v-card-title>
        <!-- /상세 상단 -->
        <!-- 내용 -->
        <v-card-text class="noti_pop_con for_dashB"
          ><br />
          안녕하세요? 비즈니스온커뮤니케이션 입니다.<br /><br />
          2024년 4월 15일부로 글로싸인엔터프라이즈 개인정보처리방침에 변경사항이 있어 안내해드립니다. <br />
          개인정보처리방침의 변경사항을 확인하시어 서비스 이용에 참고하시기 바랍니다. <br /><br />
          [개인정보처리방침 변경 내용]<br /><br />
          1. 시행시기 : 2024년 4월 15일 (월)<br />
          2. 주요개정사항 : [개인정보 보호법 및 시행령] , [개인정보의 안전성 확보조치 기준 고시] 등 에 따른 개인정보처리방침내 항목 수정 및 추가
          <br /><br />
          <table class="term_tbl">
            <colgroup>
              <col style="width:30%" />
              <col style="width:30%" />
            </colgroup>
            <tr>
              <th scope="col">변경전</th>
              <th scope="col">변경후</th>
            </tr>
            <tr>
              <td>
                글로싸인엔터프라이즈는 개인정보보호법 및 정보통신망 이용촉진 및 정보보호 등에 관한 법률에 따라 정보주체의 개인정보를 보호하고 관련된 고충을 원활하게 처리할 수 있도록 다음과 같은 처리방침을 두고 있습니다.<br/><br/>
                개인정보취급방침은 정부의 법률 및 지침의 변경과 글로싸인엔터프라이즈의 정책 변화에 따라 변경될 수 있고, 이에 따라 개인정보취급방침을 개정하는 경우 공지사항을 통하여 미리 공지하여 고객이 확인할 수 있도록 조치하고 있습니다.<br/><br/>
                글로싸인엔터프라이즈는 개인정보취급방침을 통하여 고객들이 제공하는(삭제) 개인정보가 어떠한 용도와 방식으로 이용되고 있으며 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드리고자 합니다.<br/>
              </td>
              <td>
                글로싸인엔터프라이즈는 정보주체의 개인정보 보호를 위해 「개인정보 보호법」 및 관계 법령이 정한 바를 준수하여, 적법하게 개인정보를 처리하고 안전하게 관리하고 있습니다.<br/><br/>
                개인정보처리방침은 정부의 법률 및 지침의 변경과 글로싸인엔터프라이즈의 정책 변화에 따라 변경될 수 있고, 이에 따라 개인정보처리방침을 개정하는 경우 공지사항을 통하여 미리 공지하여 고객이 확인할 수 있도록 조치하고 있습니다.<br/><br/>
                글로싸인엔터프라이즈는 개인정보처리방침을 통하여 개인정보가 어떠한 용도와 방식으로 이용되고 있으며 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드리고자 합니다.
              </td>
            </tr>
            <tr>
              <td>
                1. 수집하는 개인정보의 항목 및 수집방법<br/>
                2. 개인정보의 수집 및 이용목적<br/>
                3. 개인정보의 보유 및 이용기간<br/>
                4. 개인정보 파기절차 및 방법<br/>
                5. 개인정보 공유 및 제공<br/>
                6. 수집한 개인정보 취급위탁업무 내용 및 수탁자<br/>
                7. 이용자 및 법정대리인의 권리와 그 행사방법<br/>
                8. 개인정보 자동수집 장치의 설치,운영 및 그 거부에 관한 사항<br/>
                9. 개인정보의 기술적/관리적 보호 대책<br/>
                10. 개인정보관리책임자 및 담당자의 소속-성명 및 연락처<br/>
                11. 고지의 의무
              </td>
              <td>
                1. 개인정보의 처리목적<br/>
                2. 처리하는 개인정보 항목<br/>
                3. 개인정보의 처리 및 보유기간<br/>
                4. 개인정보의 제3자 제공<br/>
                5. 개인정보처리의 위탁<br/>
                6. 개인정보의 파기<br/>
                7. 정보주체와 법정대리인의 권리·의무 및 행사방법<br/>
                8. 개인정보의 안정성 확보 조치<br/>
                9. 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항<br/>
                10. 개인정보 보호책임자에 관한 사항<br/>
                11. 개인정보의 열람청구를 접수·처리하는 부서<br/>
                12. 정보주체의 권익침해에 대한 구제방법<br/>
                13. 개인정보 처리방침의 변경에 관한 사항
              </td>
            </tr>
          </table>
          <br />
          자세한 내용은 아래 링크를 참조해주세요.<br /><br />
          <li v-on:click="personInfo" class="poinTer_2">
            개인정보처리방침
          </li>
          <br/>
          변경된 개인정보처리방침은 2024년 4월 15일자로 효력이
          발생합니다.<br />감사합니다.<br /><br />
        </v-card-text>
        <!-- /내용 -->
        <!--버튼-->
        <v-card-actions class="justify-center btnPopcon">
          <v-btn text @click="popNoti_240415 = false">닫기</v-btn>
        </v-card-actions>
        <!--/버튼-->
      </v-card>
    </v-dialog>
    <!--스마트빌싸인 서비스명 변경:개인정보처리방침 변경 공지 변경 공지-->

    <!--스마트빌싸인 서비스명 변경:이용약관/개인정보취급방침 변경 공지-->
    <v-dialog id="mw1264_fix100" v-model="popNoti_221005" max-width="1100">
      <v-card id="popupBox" class="popW1340VH100 popDocuD_pd_bt">
        <v-card-title class="noti_pop_title align-start">
          <v-btn
            fab
            class="popBtnClose"
            @click="popNoti_221005 = false"
          ></v-btn>
          <v-list-item class="noti_carD forPop">
            <div class="carD_01">
              <div class="carD_01_txt">
                <span class="noti_chip st01">공지</span
                ><!--상태
                ***상태별 텍스트 변경***  /*일반 / st01:공지 **/-->
                <!--공지 제목--><span class="st_tt_01"
                  >이용약관/개인정보취급방침 변경 공지</span
                >
              </div>
              <div class="dateBox">
                <span class="st_txt mr-5">2022-10-05</span>
              </div>
            </div>
          </v-list-item>
        </v-card-title>
        <!-- /상세 상단 -->
        <!-- 내용 -->
        <v-card-text class="noti_pop_con for_dashB"
          ><br />
          안녕하세요? 비즈니스온커뮤니케이션 입니다.<br />
          서비스명 변경에 따른 이용약관/개인정보취급방침 변경이 있어
          공지드립니다. <br /><br />
          [이용약관/개인정보처리방침 변경 내용]<br /><br />
          <div style="line-height: 1em; color: #2b2d2c; font-weight: normal;">
            이용약관/개인정보처리방침 내 모든 서비스명이
            <span style="background:rgba(0,221,255,.3);">'스마트빌싸인'</span
            >에서
            <span style="background:rgba(0,221,255,.3);"
              >'글로싸인엔터프라이즈'</span
            >로 변경됩니다.
          </div>
          <br />
          변경된 이용약관 및 개인정보처리방침은 10월 12일부터 효력이
          발생합니다.<br />감사합니다.<br /><br />
        </v-card-text>
        <!-- /내용 -->
        <!--버튼-->
        <v-card-actions class="justify-center btnPopcon">
          <v-btn text @click="popNoti_221005 = false">닫기</v-btn>
        </v-card-actions>
        <!--/버튼-->
      </v-card>
    </v-dialog>
    <!--스마트빌싸인 서비스명 변경:이용약관/개인정보취급방침 변경 공지-->

    <!--스마트빌싸인 서비스명 변경 안내-->
    <v-dialog id="mw1264_fix100" v-model="popNoti_220923" max-width="1100">
      <v-card id="popupBox" class="popW1340VH100 popDocuD_pd_bt">
        <v-card-title class="noti_pop_title align-start">
          <v-btn
            fab
            class="popBtnClose"
            @click="popNoti_220923 = false"
          ></v-btn>
          <v-list-item class="noti_carD forPop">
            <div class="carD_01">
              <div class="carD_01_txt">
                <span class="noti_chip st01">공지</span
                ><!--상태
                ***상태별 텍스트 변경***  /*일반 / st01:공지 **/-->
                <!--공지 제목--><span class="st_tt_01"
                  >스마트빌싸인 서비스명 변경 안내</span
                >
              </div>
              <div class="dateBox">
                <span class="st_txt mr-5">2022-09-23</span>
              </div>
            </div>
          </v-list-item>
        </v-card-title>
        <!-- /상세 상단 -->
        <!-- 내용 -->
        <v-card-text class="noti_pop_con for_dashB">
          <br />
          안녕하세요? 비즈니스온커뮤니케이션 입니다.<br /><br />
          보다 나은 서비스 제공을 위해 <br />
          비즈니스온커뮤니케이션이 제공하는 전자서명 서비스 <br />
          <span style="color:#333;"
            >'스마트빌싸인'이
            <font style="color:#1e8ffa;">'글로싸인엔터프라이즈'</font>로
            서비스명을 변경합니다.</span
          ><br /><br />
          <h3 class="agree_h1">
            서비스명 변경일자 :
            <font style="color:#1e8ffa;">2022년 10월 12일 19시</font>
          </h3>
          <ul class="agree_in">
            <li>
              - 서비스명 변경과 관계없이 서비스 기능 및 사용자 접속 환경에는
              변동이 없습니다.
            </li>
            <li>- 기존 수·발신 계약서는 그대로 보존됩니다.</li>
            <li>
              - 서비스명 변경 후에도 전자계약 발송 및 수신 업무는 동일하게
              진행됩니다.
            </li>
          </ul>
          <div style="margin-top:40px; margin-bottom:40px">
            <img
              src="@/assets/img/logo.svg"
              width="201"
              height="auto"
              class="logoColor"
              alt="Glosign enterprise"
            />
          </div>
        </v-card-text>
        <!-- /내용 -->
        <!--버튼-->
        <v-card-actions class="justify-center btnPopcon">
          <v-btn text @click="popNoti_220923 = false">닫기</v-btn>
        </v-card-actions>
        <!--/버튼-->
      </v-card>
    </v-dialog>
    <!--스마트빌싸인 서비스명 변경 안내-->

    <!--이용약관/개인정보취급방침 변경 공지-->
    <v-dialog id="mw1264_fix100" v-model="popNoti01" max-width="1100">
      <v-card id="popupBox" class="popW1340VH100 popDocuD_pd_bt">
        <v-card-title class="noti_pop_title align-start">
          <v-btn fab class="popBtnClose" @click="popNoti01 = false"></v-btn>
          <v-list-item class="noti_carD forPop">
            <div class="carD_01">
              <div class="carD_01_txt">
                <span class="noti_chip st01">공지</span
                ><!--상태
                ***상태별 텍스트 변경***  /*일반 / st01:공지 **/-->
                <!--공지 제목--><span class="st_tt_01"
                  >이용약관/개인정보취급방침 변경 공지</span
                >
              </div>
              <div class="dateBox">
                <span class="st_txt mr-5">2020-12-07</span>
              </div>
            </div>
          </v-list-item>
        </v-card-title>
        <!-- /상세 상단 -->
        <!-- 내용 -->
        <v-card-text class="noti_pop_con for_dashB"
          ><br />
          안녕하세요? 스마트빌싸인 입니다.<br />
          이용약관/개인정보취급방침 변경이 있어 공지 드립니다.<br />
          <br />
          [이용약관 추가 내용]<br /><br />
          <h3 class="agree_h1">제 3 장 서비스의 제공 및 이용</h3>
          <li>
            <h4 class="agree_h2">제 9 조 (전자문서/전자서명 법적 효력)</h4>
            <ul class="agree_in">
              <li>
                ① 전자문서 및 전자거래 기본법 제4조 제1항에 의해 전자적 형태로
                되어 있다는 이유로 문서로서의 효력이 부인되지 않지만 다른 법령에
                특별한 규정이 있는 경우 법적 효력이 인정되지 않을 수 있으며 이와
                관련되어 발생하는 문제에 대해서 책임지지 않습니다.
              </li>
              <li>
                ② 전자서명에 사용되는 서명은 전자서명법 제3조 제3항에 의해
                당사자간의 약정에 따른 서명, 서명날인 또는 기명 날인으로서의
                효력을 가지지만 다른 법령에 특별한 규정이 있는 경우 법적 효력이
                인정되지 않을 수 있으며 이와 관련되어 발생하는 문제에 대해서
                책임지지 않습니다.
              </li>
            </ul>
          </li>
          <br />
          <h3 class="agree_h1">제 6 장 기타</h3>
          <h4 class="agree_h2">제 31 조 (면책조항)</h4>
          <ul class="agree_in">
            <li>
              ①계약 작성자는 계약 수신자 정보(이름, 휴대폰 번호, 메일 주소 등)의
              진위 여부를 확인한 후 계약을 발송해야하며, 잘못된 정보 입력으로
              발생하는 문제에 대해 책임지지 않습니다.
            </li>
            <li>
              ②스마트빌싸인을 통해 이뤄지는 회원 및 이용자 간에 이뤄지는
              전자계약 작성, 전송, 서명 등 진행과정과 내용 이행 등에서 발생하는
              분쟁에 대해 책임지지 않습니다.
            </li>
          </ul>
          <br />
          [개인정보처리방침 추가 내용]<br /><br />
          <h4 class="agree_h2">
            6. 수집한 개인정보 취급위탁업무 내용 및 수탁자
          </h4>
          <table class="term_tbl">
            <colgroup>
              <col style="width:40%" />
              <col style="width:60%" />
            </colgroup>
            <tr>
              <th scope="col">수탁업체</th>
              <th scope="col">위탁업무 내용</th>
            </tr>
            <tr>
              <td>시스원</td>
              <td>서비스 인프라 유지보수</td>
            </tr>
            <tr>
              <td>토스페이먼츠</td>
              <td>서비스 비용 결제 대행</td>
            </tr>
            <tr>
              <td>세종텔레콤</td>
              <td>SMS 메세징 서비스</td>
            </tr>
            <tr>
              <td>비즈톡</td>
              <td>카카오톡 메세징 서비스</td>
            </tr>
            <tr>
              <td>KCB</td>
              <td>본인인증 서비스</td>
            </tr>
          </table>
          <br />
          <br />변경된 이용약관 및 개인정보처리방침은 12월 14일부터 효력이
          발생합니다.<br />감사합니다.<br /><br /><br />
        </v-card-text>
        <!-- /내용 -->
        <!--버튼-->
        <v-card-actions class="justify-center btnPopcon">
          <v-btn text @click="popNoti01 = false">닫기</v-btn>
        </v-card-actions>
        <!--/버튼-->
      </v-card>
    </v-dialog>
    <!--이용약관/개인정보취급방침 변경 공지-->

    <!--스마트빌싸인 리뉴얼 오픈 안내-->
    <v-dialog id="mw1264_fix100" v-model="popNoti02" max-width="1100">
      <v-card id="popupBox" class="popW1340VH100 popDocuD_pd_bt">
        <v-card-title class="noti_pop_title align-start">
          <v-btn fab class="popBtnClose" @click="popNoti02 = false"></v-btn>
          <v-list-item class="noti_carD forPop">
            <div class="carD_01">
              <div class="carD_01_txt">
                <span class="noti_chip">일반</span
                ><!--상태
                ***상태별 텍스트 변경***  /*일반 / st01:공지 **/-->
                <!--공지 제목--><span class="st_tt_01"
                  >스마트빌싸인 리뉴얼 오픈 안내</span
                >
              </div>
              <div class="dateBox">
                <span class="st_txt mr-5">2020-12-07</span>
              </div>
            </div>
          </v-list-item>
        </v-card-title>
        <!-- /상세 상단 -->
        <!-- 내용 -->
        <v-card-text class="noti_pop_con for_dashB"
          ><br />
          안녕하세요? 스마트빌싸인 입니다.<br />
          스마트빌 전자계약이 스마트빌싸인으로 새로워졌습니다.<br />
          더 편리하고 안전한 전자계약을 경험해보세요!<br /><br />감사합니다.<br /><br /><br />
        </v-card-text>
        <!-- /내용 -->
        <!--버튼-->
        <v-card-actions class="justify-center btnPopcon">
          <v-btn text @click="popNoti02 = false">닫기</v-btn>
        </v-card-actions>
        <!--/버튼-->
      </v-card>
    </v-dialog>
    <!--스마트빌싸인 리뉴얼 오픈 안내-->
    <!--/팝업-->
    <perInfoProtec ref="perInfoProtec"></perInfoProtec>
  </v-container>
</template>
<script>
import { getStatCount } from "@/api/dashboard/dashboard";
import { getCurrPoint } from "@/api/payment/payment";
import { getUserImgList } from "@/api/userImg";
import perInfoProtec from "@/components/perInfoProtec";

export default {
  name: "dashboard",
  components: {
    perInfoProtec
  },
  filters: {
    WithComma: function(money) {
      if (String(money)) {
        return String(money).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    }
  },
  data() {
    return {
      // 공지
      popNoti01: false,
      popNoti02: false,
      popNoti_220923: false,
      popNoti_221005: false,
      popNoti_240415: false,
      popNoti_240719: false,
      // popNoti_240911: false,
      popNoti_241118: false,
      popNoti_250123: false,
      // 이벤트 슬라이더
      cycle: false,
      activeName: "company",
      /* 이용 가능 포인트 */
      availableNumber: 0,
      /* 이용 가능 포인트 */
      availablePoint: 0,
      slides: [],
      statCount: {
        totalCnt: 0,
        prCnt: 0,
        crrCnt: 0,
        crsCnt: 0,
        cnCnt: 0
      },
      ctrSignal: "company",
      UserImgUrl: ""
    };
  },
  created() {},
  mounted() {
    if (this.$store.state.user.orgaddr) {
      this.activeName = "company";
      this.companyYN = true;
    } else {
      this.activeName = "personal";
    }
    this.track();
    this.$nextTick(() => {
      this.getStatCount();
      this.getUserImgList();
    });
  },
  methods: {
    track() {
      this.$gtag.pageview({
        page_path: "/dashBoard"
      });
    },
    goFeepay() {
      this.$router.push({ name: "feePay" });
    },
    document() {
      this.$router.push({ name: "document" });
    },
    getName() {
      this.userName = this.$store.state.user.username;
      return this.$store.state.user.username;
    },
    getOrgname() {
      return this.$store.state.user.orgname;
    },
    goWrite() {
      this.$router.push({ name: "writeContract" });
    },
    personInfo() {
      this.$refs.perInfoProtec.open();
    },
    openBanner() {
      // 이벤트 오픈
      // window.open(
      //   "./event01",
      //   "_blank ",
      //   "width = 800, height=740, scrollbars=yes, resizable=no, status=no, location=no, toolbars=no, menubar=no"
      // );
    },
    getStatCount() {
      if (this.getOrgname()) {
        this.ctrSignal = "company";
      } else {
        this.ctrSignal = "personal";
      }
      getStatCount(JSON.stringify({ ctrSignal: this.ctrSignal }))
        .then(response => {
          this.statCount.totalCnt = response.rdata.totalCnt;
          this.statCount.prCnt = response.rdata.prCnt;
          this.statCount.crrCnt = response.rdata.crrCnt;
          this.statCount.crsCnt = response.rdata.crsCnt;
          this.statCount.cnCnt = response.rdata.cnCnt;
        })
        .catch(e => {
          console.error(e);
        });
      getCurrPoint({
        chainAddr: this.getChainAddress(),
        activeName: this.ctrSignal
      })
        .then(response => {
          if (response.rdata.code === 1) {
            this.availablePoint = response.rdata.currPoint;
            this.availableNumber = parseInt(this.availablePoint / 3000);
          } else {
            this.$refs.confirm.open(
              "alert",
              "포인트 조회",
              response.rdata.message
            );
          }
        })
        .catch(e => {
          // console.log(e)
        });
    },
    // storage(ctrStat) {
    // 	this.$router.push({ name: "storage", params: { ctrStat: ctrStat } });
    // },
    storage() {
      this.$router.push({ name: "storage" });
    },
    sorgConfig() {},
    getChainAddress() {
      var chainAddr;
      if (this.activeName === "company") {
        chainAddr = this.$store.state.user.orgaddr;
      } else {
        chainAddr = this.$store.state.user.useraddr;
      }

      return chainAddr;
    },
    getUserImgList() {
      getUserImgList(
        JSON.stringify({ chainAddress: this.getChainAddress() })
      ).then(response => {
        if (response.rdata.userImg) {
          this.UserImgUrl =
            process.env.VUE_APP_URL_USER_THUMBNAIL +
            response.rdata.userImg.imgSequence;
        } else {
          this.UserImgUrl = "";
        }
      });
    }
  }
};
</script>
<style scoped></style>
